import request from '@/apis/request'
const resource = 'vip-ranks' 

export default {
  get: (params = {}) => {
    return request.get(`${resource}`, { params })
  }, 
}